<template>
  <div class="summary-card-header" :class="variantClass">
    <div class="summary-card-icon">
      <i :class="icon"></i>
    </div>
    <h5>{{ title }}</h5>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  title: string;
  icon?: string;
  variant?: string;
}>(), {
  icon: '',
  variant: 'secondary',
})

const variantClass = computed((): string => `variant-${props.variant}`)
</script>

<style scoped>
.summary-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: var(--surface-card);
  border-bottom: 1px solid var(--surface-border);
}

.summary-card-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.summary-card-header h5 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-color);
}

.variant-secondary .summary-card-icon {
  background: rgba(var(--app-secondary-color-rgb), 0.12);
}

.variant-secondary .summary-card-icon i {
  color: var(--app-secondary-color);
}

.variant-primary .summary-card-icon {
  background: rgba(var(--app-primary-color-rgb), 0.12);
}

.variant-primary .summary-card-icon i {
  color: var(--app-primary-color);
}

.variant-success .summary-card-icon {
  background: rgba(34, 197, 94, 0.12);
}

.variant-success .summary-card-icon i {
  color: #22c55e;
}

.variant-warning .summary-card-icon {
  background: rgba(245, 158, 11, 0.12);
}

.variant-warning .summary-card-icon i {
  color: #f59e0b;
}

.variant-danger .summary-card-icon {
  background: rgba(239, 68, 68, 0.12);
}

.variant-danger .summary-card-icon i {
  color: #ef4444;
}

.variant-info .summary-card-icon {
  background: rgba(59, 130, 246, 0.12);
}

.variant-info .summary-card-icon i {
  color: #3b82f6;
}

.variant-blue .summary-card-icon {
  background: rgba(59, 130, 246, 0.12);
}

.variant-blue .summary-card-icon i {
  color: #3b82f6;
}

.variant-green .summary-card-icon {
  background: rgba(34, 197, 94, 0.12);
}

.variant-green .summary-card-icon i {
  color: #22c55e;
}

.variant-purple .summary-card-icon {
  background: rgba(168, 85, 247, 0.12);
}

.variant-purple .summary-card-icon i {
  color: #a855f7;
}
</style>
